<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs" id="custom-content-above-tab" role="tablist">
              <li class="nav-item">
                 <router-link to="/cashback_paid" class="nav-link">
                   CASHBACK</a>
                </router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link active" data-toggle="pill" href="javascript:void(0)" aria-selected="true">  PPN</a>
              </li>
              <li class="nav-item">
                <router-link to="/pph_paid" class="nav-link">
                   PPH 23</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/zakat_paid" class="nav-link">
                   ZAKAT</a>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Daftar PPN Paid <small></small></h3>
                <div class="card-tools">
                        <!--button type="button" class="btn btn-sm btn-success" @click="false">
                            <i class="fa fa-check-square"></i>
                            &nbsp; PAID
                        </button>
                        <button type="button" class="btn btn-sm btn-danger" @click="false">
                            <i class="fa fa-credit-card"></i>
                            &nbsp; CREATE VA
                        </button>
                        <button type="button" class="btn btn-sm btn-warning" @click="false">
                            <i class="fa fa-print"></i>
                            &nbsp; Print Invoice
                        </button-->
                        <v-dialog
                            ref="dialog"
                            v-model="modaltgl"
                            :return-value.sync="tanggal_query"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field style="margin-top:0px;padding-top:0px"
                                v-model="tanggal_query"
                                label=""
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="tanggal_query"
                            type="month"
                            scrollable
                            min="2022-05"
                            :max="dateMax"
                            
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="modaltgl = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="ubahTanggalTampil($refs)"
                            >
                                OK
                            </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </div>
              </div>
              <!-- /.card-header -->
              <v-app>
                <v-content>
                  <div class="card-body ">
                    <div class="row">
                      <div class="col-lg-3 col-3">
                        <div class="small-box bg-primary">
                            <div class="inner">
                                <h5>{{parseInt(datas.length)}}</h5>
                                <small>Jumlah PPN Paid</small>
                                <!--p>dari {{parseInt(jlh_invoice)}} Unpaid Bulan Ini</p-->
                            </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-3">
                        <div class="small-box bg-primary">
                            <div class="inner">
                                <h5>{{parseInt(jumlah_manual) | toCurrency}}</h5>
                                <small>Total Rp PPN Manual</small>
                                <!--p>Unpaid Bulan Ini</p-->
                            </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-3">
                        <div class="small-box bg-primary">
                            <div class="inner">
                                <h5>{{parseInt(jumlah_auto) | toCurrency}}</h5>
                                <small>Total Rp PPN Auto</small>
                                <!--p>Unpaid Bulan Ini</p-->
                            </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-3">
                        <div class="small-box bg-success">
                            <div class="inner">
                                <h5>{{parseInt(jumlah_semuanya) | toCurrency}}</h5>
                                <small>Total Rp PPN Paid</small>
                                <!--p>Unpaid Bulan Ini</p-->
                            </div>
                        </div>
                      </div>
                    </div>
                    <!-- Print -->
                    <div class="row">
                      <div class="col-lg-12 col-12">
                        <v-text-field
                          class="col-md-4 offset-md-8 mb-1"
                          v-model="cari_dt_plg"
                          append-icon="mdi-magnify"
                          label="Pencarian"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-data-table
                          :headers="headers"
                          :footer-props="{ itemsPerPageOptions: [10,25,50,100,-1]}"
                          :items="datas"
                          :items-per-page="25"
                          item-key="id"
                          sort-by="no"
                          class="elevation-1 "
                          show-group-by
                          :search="cari_dt_plg">
                          <template v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                            <td :colspan="headers.length-1">
                              <v-btn @click="toggle" x-small icon :ref="group">
                                  <v-icon v-if="isOpen">mdi-minus</v-icon>
                                  <v-icon v-else>mdi-plus</v-icon>
                              </v-btn>
                              <span class="mx-3"> Nama Pelanggan : <span class="font-weight-bold"> {{ group }}</span></span>
                              <!--a href="#" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                                <i class="fa fa-user-edit text-blue"></i>
                              </a-->
                            </td>
                            <td>
                              <v-btn @click="remove" x-small icon class="">
                                  <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <template v-slot:header.checkbox>
                            <input type="checkbox" @click="checkAll()" v-model="isCheckAll">
                          </template>
                          <template v-slot:item.checkbox="{ item }">
                            <v-container
                              class="px-0"
                              fluid
                            >
                              <v-checkbox @change="updateCheckall(item)" v-model="listItemSelek" v-bind:value="item"
                              ></v-checkbox>
                            </v-container>
                          </template>
                          <template v-slot:item.tbl_bayar="{ item }">
                            {{ item.tbl_bayar | toCurrency }}
                          </template>
                          <template v-slot:item.bayar_oleh="{ item }">
                            {{ item.bayar_oleh ? item.bayar_oleh : 'Auto Potong' }} 
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <!--a href="#" v-if="!table_group_state" class="mr-1" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                              <i class="fa fa-user-edit text-blue"></i>
                            </a-->
                            <div class="tanpawrap">
                              <a href="#" class="mr-1" @click="printInvoice(item)" title="Lihat Invoice">
                                <i class="fa fa-file text-yellow"></i>
                              </a>
                              /
                              <a href="#" class="ml-1" @click="bukaModal(item)" title="View Data">
                                <i class="fa fa-eye text-blue"></i>
                              </a>
                            </div>
                            <!--a href="#" class="ml-1" @click="false">
                              <i class="fas fa-trash text-red"></i>
                            </a-->
                            <!--a href="#" @click="deleteProduct(item.id)">
                              <i class="fas fa-trash text-red"></i>
                            </a-->
                            
                          </template>
                          <template v-slot:no-data>
                            <h4>Data Tidak Ditemukan</h4>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </div>
                </v-content>
              </v-app>
              <!-- /.card-body -->
        
              <div class="card-footer">
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
    </div>
          <div class="modal fade " id="modalEdit" tabindex="-1" role="dialog" aria-labelledby="modalEdit" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Penyelesaian PPN</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="bayarCashback()" enctype="multipart/form-data" id="formnya">
                    <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card card-outline card-primary">
                              <div class="card-header">
                                <h3 class="card-title" style="margin:0px">Data Pelanggan</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                
                                
                                <hr style="border:1px solid;"/>
                                <h5>Data Billing</h5>
                                
                              </div>
                              <!-- /.card-body -->
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                modaltgl: false,
                menu2: false,
                menu: false,
                jumlah_auto : 0,
                jumlah_manual : 0,
                jumlah_semuanya : 0,
                cari_dt_plg: '',
                datas : [],
                headers: [
                  { text: 'No Inv', value: 'id', groupable: false, },
                  { text: 'ID PLG', value: 'inet_id', sortable: false, groupable: false, },
                  { text: 'Nama PLG', value: 'nama', sortable: false, groupable: false, },
                  { text: 'Tempat Instalasi', value: 'nama_tempat', groupable: false, },
                  { text: 'Tanggal Bayar Cashback', value: 'tanggal_bayar', groupable: false, },
                  { text: 'Jumlah PPN', value: 'tbl_bayar', groupable: false, },
                  { text: 'Dibayar Oleh', value: 'bayar_oleh', groupable: false, },
                  { text: 'Aksi', value: 'actions' , sortable: false, groupable: false,},
                ],
            }
        },
        methods: {
          countJumlahnya(){
            Object.entries(this.datas).forEach(([key, val]) => { 
              if(val.bayar_oleh){
                this.jumlah_manual += parseInt(val.tbl_bayar);
              }else{
                this.jumlah_auto += parseInt(val.tbl_bayar);
              }  
            });
            
            this.jumlah_semuanya = this.jumlah_manual + this.jumlah_auto;
          },
          ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            this.loadData();       
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          downloadFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: 'application/pdf'});

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download = filename + '.pdf'
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
          },
          printInvoice(item){
            this.$Progress.start();
            let namaFileDownload = "Invoice " + item.nama + " " + item.bulan_pemakaian;
            axios.get('api/invoice/printpdf?id_invoice='+item.id, {responseType: 'blob'}).then(response => {
              this.downloadFile(response, namaFileDownload);
              this.$Progress.finish();
            }, response => {
                Toast.fire({
                    icon: 'error',
                    title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
                });
                this.$Progress.fail();
            });
          },
          bukaModal(item){
            this.adaeror = [];
            this.form.reset();
            $('#modalEdit').modal('show');
          },
          tableGrouping(e) {
            if(e.length){
              this.table_group_state = true;
            }else{
              this.table_group_state = false;
            }
          },
          loadData(){
            let tahun = this.tanggal_query.substr(0, 4);
            let bulan = this.tanggal_query.substr(-2, 2);
            this.jumlah_auto = 0;
            this.jumlah_manual = 0;
            this.jumlah_semuanya = 0;
            if(this.$gate.isAllowed("is_keuangan")){
              
              if(this.$gate.dataType('1')){
                axios.get("api/ppn/list_paid?tahunpaid="+tahun+"&bulanpaid="+bulan).then(({ data }) => {
                
                  if(data.data.length){
                    this.datas = data.data;
                    this.countJumlahnya();
                  }else{
                    this.datas = [];
                  }
                });
              }
            }
            this.tanggal_tampil = this.getBulan(this.tanggal_query);
          },
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadData();

            this.$Progress.finish();
        },
    }
</script>
<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.tanpawrap {
  white-space: nowrap;
}
</style>